import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SETTINGS } from '../config/common.settings';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class OtherReservationService {
  constructor(private http: HttpClient) {}

  createOtherReservation(payload: any): Observable<any> {
    return this.http.post(
      `${SETTINGS.BASE_API}/other-bookings/create`,
      payload,
    );
  }

  getOtherReservationsPaged(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/other-bookings/get-paged`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }

  getOtherBookingById(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${SETTINGS.BASE_API}/other-bookings/get/${payload}`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }

  getOtherBookingNormalById(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${SETTINGS.BASE_API}/other-bookings/get-one/${payload}`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }

  updateBooking(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .put(`${SETTINGS.BASE_API}/other-bookings/update`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error.error.message);
          },
        });
    });
  }
}
